import { TextCell } from '@common/components/TextCell';

interface StateCellProps {
	/** The registration state abbreviation */
	state?: string;
}

export const StateCell = ({ state }: StateCellProps) => {
	return <TextCell value={state} />;
};
